import { CAST_AI } from '@cast/constants';
import { Icons, Button, HexIcon, tokens } from '@cast/design-system';
import { useTrial, TrialBannerLayout } from '@cast/shared-trial-ui';

import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { useTrialHasEndedDialog } from '../dialogs/useTrialHasEndedDialog';

export const TrialHasEndedBanner = () => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible, state } = useTrial();
  const { openDialog: openTrialHasEndedDialog } = useTrialHasEndedDialog();

  if (
    !isEligible ||
    accountReadOnly ||
    (state !== 'grace-period' && state !== 'post-trial')
  ) {
    return null;
  }

  return (
    <TrialBannerLayout
      testId="trial-has-ended-banner"
      sx={{
        backgroundColor: tokens.theme.bg.categorical.redSubtle,
        border: '1px solid',
        borderColor: tokens.theme.border.status.error,
      }}
      icon={
        <HexIcon
          icon={<Icons.XCircle />}
          size={58}
          iconColor={tokens.theme.fg.status.error}
          hexColor={tokens.theme.data.red200}
        />
      }
      title="Your trial has finished – let's talk about your next steps"
      titleTypographyProps={{
        color: 'textPrimary',
      }}
      description={`We understand you need time to evaluate your options. You have 7 days of continued access to premium features while you decide how to proceed with your ${CAST_AI} experience.`}
      descriptionTypographyProps={{
        color: 'textSecondary',
      }}
      cta={
        <Button
          testId="take-actions-button"
          variant="ghost"
          endIcon={<Icons.ArrowRight />}
          onClick={() => openTrialHasEndedDialog()}
        >
          Take actions
        </Button>
      }
    />
  );
};
